import _get from "lodash/get";
import store from "@/store";
import {
  httpSuccessResponseLogger,
  httpErrorResponseLogger
} from "@/helpers/logger";
import _ from "lodash";
import { redirectToProperErrorPage } from "@/helpers/router";

export default function({ next, to, router }) {
  const id = _get(to, "params.id");

  store
    .dispatch("projectOverview/project/getData", { id })
    .then(response => {
      httpSuccessResponseLogger(response);

      const project = _.get(response, "data.result");

      store.commit("projectOverview/wetstamps/SET_PROJECT_WETSTAMP", project);

      return next();
    })
    .catch(error => {
      httpErrorResponseLogger(error);

      redirectToProperErrorPage(error, to, router);
    });
}
